import React, { useContext, useEffect, useRef } from 'react';
import { RefreshBar } from '../../shared/components/table/RefreshBar';
import { AppStateContext } from '../../AppState';
import { SkeletonTable } from '../../shared/components/Skeleton';
import { TablePagination } from '../../shared/components/table/TablePagination';
import { TicketListBoard } from '../../shared/components/table/TicketListBoard';
import { Ticket } from '../../shared/interfaces/ticket.interface';
import { ListContext } from './ListContextProvider';
import ListFunctions from './ListFunctions';
import useCustomViewsTickets from './useCustomViewsTickets';
import { ResultCount } from '../../shared/components/ResultCount';

interface Props {
  onTicketsSelected: (tickets: Ticket[]) => void;
  defaultFilters: FilterPropsItems[];
  listFeatureStates: ListFeatureStates;
}



export const List = ({ onTicketsSelected, defaultFilters, listFeatureStates }: Props) => {
  const state = useContext(AppStateContext);
  const { listStates } = useContext(ListContext);
  const { moveToPage, countPerPage, getpaginatedTickets } = ListFunctions();

  // Refresh on the table (TicketToolbar): page one again, with the rows left on screen while it loads. The board
  // shares the trigger and it stays set, so only one newer than the one present at mount counts.
  const handledRefreshTrigger = useRef(listStates.refreshTrigger);
  useEffect(() => {
    if (!listStates.refreshTrigger || listStates.refreshTrigger === handledRefreshTrigger.current) return;
    handledRefreshTrigger.current = listStates.refreshTrigger;
    getpaginatedTickets({ page: 1, count: listStates.countPerPage });
  }, [listStates.refreshTrigger]);

  useCustomViewsTickets({ defaultFilters }); // Get tickets filtered by custom views

  return (
    <>
      {listStates.isTicketsFetching && <SkeletonTable />}
      {!listStates.isTicketsFetching && (
        <>
          <div className={listStates.isTicketsRefreshing ? 'list-rows-refreshing' : undefined} style={{ height: 'calc(100vh - 139px - 2.25rem)', overflow: 'auto' }}>
            {listStates.isTicketsRefreshing && <RefreshBar />}
            <TicketListBoard appStateValue={state} filterDropdownCount={state.filterDropdownCount} onTicketsSelected={onTicketsSelected} isFilterApplied={state.isFilterApplied} listFeatureStates={listFeatureStates} />
          </div>
          <div className='pr-4 h-9 flex items-center'>
            <ResultCount count={listStates.countTickets} />
            <TablePagination currentPage={listStates.currentPage} totalCount={listStates.countTickets} moveToPage={moveToPage} itemsPerPage={listStates.countPerPage} itemsPerPageChanged={countPerPage} />
          </div>
        </>
      )}
    </>
  );
};
